<template>
    <BreadCrumb PageTitle="Liste des intervalles de poids" />
    <ListeIntervallePoids/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import ListeIntervallePoids from "../../components/IntervallePoids/ListeIntervallePoids.vue";

    export default defineComponent({
      name: "ListeIntervallePoidsPage",
      components: {
        BreadCrumb,
        ListeIntervallePoids,
      },
    });
  </script>